<template>
    <div class="item">
        <div class="brand-row">
            <div class="dFlex" v-if="!filtered">
                <img :src="carItem.BrandImageUrl"/>
                <h4 style="padding-right: 5px;">قیمت خودرو {{carItem.Title}}</h4>
            </div>
            <div class="dFlex" v-if="filtered">
                <h5 style="padding-right: 5px;">قیمت محصول جستجو شده "<span>{{carItem.Title}}</span>"</h5>
            </div>
        </div>
        <div>
            <carPriceModelItem :carModelItem="item" v-for="item in carItem.Cars" :key="item.Id"></carPriceModelItem>
        </div>
    </div>
</template>

<script>
import carPriceModelItem from "../../components/carService/CarPriceModelItem";

export default {
    name: "car-price-item",
    components: { carPriceModelItem },
    props: {
        carItem: { 
            required: true},
        filtered: { 
            type: Boolean,
            required: true }
    },
}
</script>

<style scoped>
.brand-row{display: flex;justify-content: center;align-items: center;position: sticky;top:0;z-index: 100; background: #fff; border-bottom: 1px solid #ccc;
padding: 0; margin: 0 12px;}
.brand-row > div:first-child > img{height: 48px;}
.item { text-align: right; padding: 0; margin: 10px 6px 0 6px; border-radius: 10px; display: flex; flex-direction: column; position: relative; text-align: center; box-shadow: 0 1px 3px 1px #ccc;}
.item > div { padding: 5px 10px; text-align: right; }
.item h2 { padding: 8px; }

.item i { color: white; border-radius: 50%; background-color: #222; padding: 5px; margin-left: 5px; }
.brand-row span{
    color: #1030db;
}
</style>
